export type ReaderPreferences = {
  size: 'small' | 'standard' | 'large';
  width: 'standard' | 'wide';
};
export const defaultReaderPreferences: ReaderPreferences = { size: 'standard', width: 'standard' };
export type ReaderPosition = {
  v: 1;
  snapshotId: string;
  anchorId: string | null;
  offset: number;
  scrollTop: number;
};
export type ReadingBlock = { id: string; top: number; height: number };

export function parseReaderPreferences(value: string | null): ReaderPreferences {
  try {
    const parsed = JSON.parse(value || 'null');
    return {
      size: ['small', 'standard', 'large'].includes(parsed?.size) ? parsed.size : 'standard',
      width: ['standard', 'wide'].includes(parsed?.width) ? parsed.width : 'standard',
    };
  } catch {
    return { ...defaultReaderPreferences };
  }
}

export function parseReaderPosition(
  value: string | null,
  snapshotId: string,
): ReaderPosition | null {
  try {
    const parsed = JSON.parse(value || 'null');
    if (
      parsed?.v !== 1 ||
      parsed.snapshotId !== snapshotId ||
      !(
        parsed.anchorId === null ||
        (typeof parsed.anchorId === 'string' && /^block-\d+$/.test(parsed.anchorId))
      ) ||
      !Number.isFinite(parsed.offset) ||
      Math.abs(parsed.offset) > 1e8 ||
      !Number.isFinite(parsed.scrollTop) ||
      parsed.scrollTop < 0 ||
      parsed.scrollTop > 1e8
    )
      return null;
    return parsed as ReaderPosition;
  } catch {
    return null;
  }
}

export function captureReaderPosition(
  snapshotId: string,
  scrollTop: number,
  blocks: ReadingBlock[],
): ReaderPosition {
  let anchor = blocks[0];
  for (let index = blocks.length - 1; index >= 0; index--) {
    if (blocks[index]!.top <= scrollTop + 24) {
      anchor = blocks[index];
      break;
    }
  }
  return {
    v: 1,
    snapshotId,
    anchorId: anchor?.id || null,
    offset: anchor ? scrollTop - anchor.top : 0,
    scrollTop,
  };
}

export function readerScrollTarget(
  position: ReaderPosition,
  blocks: ReadingBlock[],
  maximum: number,
): number {
  const anchor = blocks.find((block) => block.id === position.anchorId);
  return Math.max(0, Math.min(maximum, anchor ? anchor.top + position.offset : position.scrollTop));
}
